import React from 'react';
import { Navigate } from 'react-router-dom';
import { useLanguage } from '../utils/language';
import {
  GUEST_GUIDE_DEFAULT_LANGUAGE,
  normalizeGuestGuideLanguage
} from '../constants/guestArtistGuide';

const getGuidePath = (lang) => (
  lang === GUEST_GUIDE_DEFAULT_LANGUAGE ? '/guest-conditions' : `/guest-conditions/${lang}`
);

const GuestGuidePage = () => {
  const lang = normalizeGuestGuideLanguage(useLanguage(), 'ko');

  return <Navigate to={getGuidePath(lang)} replace state={{ returnTo: '/guest' }} />;
};

export default GuestGuidePage;
